import { module } from "angular";
import { TokenRepository } from "./TokenRepository";

module("mmAuth").service("mmInternalTokenRepository", TokenRepository);
